import React, { useState } from 'react';
import {
    useRecordContext,
     Confirm
} from 'react-admin';
import { read_cookie } from "sfcookies";
import {
    Box,
    IconButton,
    CircularProgress,
} from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { hostUrl, UseUrlManagerCleanUrl } from "../../../utils/url-manager";


export const TokenItem = () => {
    const record = useRecordContext();
    const [loading, setLoading] = useState<boolean>(false);
    // HQAPI-99. The token used to come off the operators collection, which handed a working
    // credential to every admin who could read it. It is held out of the API now, so this
    // starts empty and fills in from the reset response below - `admin_operator_token_reset`
    // has always returned the new token in its own body, which is the only moment anyone
    // needs to read one: to copy it into the Operator's .env.
    const [operatorToken , setOperatorToken] = useState<string>('');
    const [open, setOpen] = useState(false);

    async function generateNewToken(): Promise<void> {
        setLoading(true);
        let url: string = hostUrl + 'hq/operator/token/reset';
        url = UseUrlManagerCleanUrl({ url: url })
        const token: string = read_cookie("auth");
        const request: Request = new Request(url, {
            method: "POST",
            body: JSON.stringify( { operator: record.id } ),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token': token
            }),
        });
        return fetch(request)
            .then( (response: Response) => {
                return response.json();
            })
            .then( async (data: any) => {
                if (data['message'] !== undefined && data['message'] === 'success') {
                    setOperatorToken(data['token']);
                }
                setLoading(false);
            })
            .catch( (error: Error) => {
                console.log(error);
                setLoading(false);
            })
    }

    function handleDialogClose(): void {
        setOpen(false);
    }

    function handleDialogOpen(): void {
        // Focus left on the trigger is hidden from assistive technology while the dialog is open,
        // and Chrome logs "Blocked aria-hidden" for it (HQ-50).
        (document.activeElement as HTMLElement|null)?.blur();
        setOpen(true);
    }

    if (!record) {
        return null;
    }

    return (
        <Box sx={ {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
        } }>
            <Box>
                <span>{"HQ Token: "}</span>
                <span>{ operatorToken === ''
                    ? 'hidden until you generate a new one'
                    : operatorToken }</span>
            </Box>
            <Box>
                <IconButton
                    disabled={ loading }
                    title="Generate new token" onClick={ handleDialogOpen }>
                    { (!loading) &&
                        <AddBoxIcon />
                    }
                    { (loading) &&
                        <CircularProgress sx={ { width: '25px !important', height: '25px !important' } } />
                    }
                </IconButton>
                <Confirm
                    isOpen={open}
                    loading={ loading }
                    title={ "Confirmation" }
                    content="Are you sure you want to generate a new token, this might effect Operator operations?"
                    onConfirm={ generateNewToken }
                    onClose={ handleDialogClose }
                />
                <span>{ "Update the Operator .env with the new Token or errors will occur" }</span>
            </Box>
        </Box>
    );
}